import "./style.scss";

import DateFieldPicker from "components/shared/DateFieldPicker";
import DateFormComponent from "components/shared/FormComponent/DateFormComponent";
import LabelComponent from "components/shared/LabelComponent";
import StyledButton from "components/shared/StyledButton";
import { StyledDatePicker } from "components/shared/StyledDatePicker";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import { PortalType } from "contexts/portal.context";
import { TinyBody } from "helpers/TypographyComponents";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";

interface ConfirmDownloadModal {
    /**
     * Triggers closing of modal (staing with the Payment Export flow)
     */
    onClose: VoidFunction;
    /**
     * Triggers the closing of the Payment Export flow.
     */
    onConfirmation: (paymentDate: Date | null) => Promise<void>;
    /**
     * Whether the download is in progress.
     */
    isDownloading: boolean;
}

/**
 * This modal checks whether user has downloaded the bank file before leaving the flow.
 */
const ConfirmDownloadModal = ({ onClose, onConfirmation, isDownloading }: ConfirmDownloadModal) => {
    const [t] = useTranslation();
    const portalType = useContext(PortalType);

    const [paymentDate, setPaymentDate] = useState<Date | null>(new Date());

    return (
        <div className="confirmation-modal-container">
            <div className="confirmation-text">
                <h3>{t("PaymentModal.ExitConfirmationTitle")}</h3>
                <span>{t(`PaymentModal.ExitConfirmationText1_${portalType}`)}</span>
                <span>{t(`PaymentModal.ExitConfirmationText2_${portalType}`)}</span>
            </div>
            <div className="confirmation-date-picker">
                <LabelComponent htmlFor="paymentDate">{t("Management.PaymentDateModal.ModalTitle")}</LabelComponent>
                <StyledDatePicker
                    value={paymentDate}
                    onChange={(e) => setPaymentDate(e)}
                    disabled={false}
                    renderInput={(params) => <StyledTextField name="paymentDate" fullWidth {...params} />}
                />
            </div>
            <div className="confirmation-action-btns">
                <StyledButton buttonType="secondary" onClick={onClose}>
                    {t("ModalBase.No")}
                </StyledButton>
                <StyledButton buttonType="primary" onClick={() => onConfirmation(paymentDate)} loading={isDownloading}>
                    {t("ModalBase.Yes")}
                </StyledButton>
            </div>
        </div>
    );
};

export default ConfirmDownloadModal;
